import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, today, useSubmit } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";
import PatientPicker from "@/components/PatientPicker";

const FIELDS = [
  ["chief_complaint", "Chief complaint"], ["examination", "Clinical examination"], ["diagnosis", "Diagnosis"],
  ["radiographic_findings", "Radiographic findings (IOPA / OPG)"], ["procedures", "Procedures done"], ["prescription", "Prescription"], ["notes", "Notes"],
];

export default function ClinicalForm({ patientId, record, onClose, onSaved }) {
  const [form, setForm] = useState(record || { patient_id: patientId || "", visit_date: today(), tooth_numbers: "", consent: false });
  const { busy, error, run } = useSubmit();
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const save = () => run(async () => {
    const body = { visit_date: form.visit_date, tooth_numbers: form.tooth_numbers || "", consent: !!form.consent, ...Object.fromEntries(FIELDS.map(([k]) => [k, form[k] || ""])) };
    const r = record ? await api.patch(`/clinical-records/${record.id}`, body) : await api.post("/clinical-records", { ...body, patient_id: form.patient_id });
    toast.success(record ? "Clinical record updated" : "Clinical record saved");
    onSaved(r.data);
  });
  return (
    <Modal eyebrow="CLINICAL RECORD" title={record ? "Edit visit note" : "New visit note"} onClose={onClose} onSubmit={save} testid="clinical-form" wide>
      {!patientId && !record && <PatientPicker value={form.patient_id} onChange={set("patient_id")} testid="clinical-patient-select" />}
      <div className="form-two">
        <Field label="Visit date" type="date" testid="clinical-date-input" required value={form.visit_date} onChange={set("visit_date")} />
        <Field label="Tooth numbers (FDI)" testid="clinical-teeth-input" value={form.tooth_numbers} onChange={set("tooth_numbers")} placeholder="e.g. 36, 46" />
      </div>
      {FIELDS.map(([k, l]) => <Field key={k} label={l} textarea testid={`clinical-${k.replaceAll("_", "-")}-input`} value={form[k]} onChange={set(k)} rows={2} />)}
      <label className="check-row"><input type="checkbox" data-testid="clinical-consent-checkbox" checked={!!form.consent} onChange={(e) => set("consent")(e.target.checked)} /> Informed consent taken</label>
      <ErrorBox error={error} testid="clinical-form-error" />
      <button className="primary full" disabled={busy} data-testid="save-clinical-button"><Check size={17} /> {busy ? "Saving…" : "Save clinical record"}</button>
    </Modal>
  );
}
